import type { DocWritingFormat } from '../api/docWritingStream'
import { isDocumentBodyEmpty } from './documentBodyEmpty'
import type { WelcomeSuggestion } from './docWritingWelcome'

export function buildReadingWelcomeGreeting(
  title: string,
  category: string,
  format: DocWritingFormat,
  getDocumentContent: () => string,
): string {
  const subject = title.trim() || category.trim()
  const hasBody = !isDocumentBodyEmpty(getDocumentContent(), format)
  if (subject && hasBody) {
    return `我已加载「${subject}」的正文，可以回答文档说明了什么、有哪些要点，或帮你提炼摘要。\n\n选一项常见问题，或直接输入你的问题。`
  }
  if (subject && !hasBody) {
    return `当前文档「${subject}」正文为空，暂无法基于内容问答。请先编辑并保存正文后再预览提问。`
  }
  if (hasBody) {
    return '我已加载当前文档正文，可以回答文档说明了什么、有哪些要点，或帮你提炼摘要。\n\n选一项，或直接提问。'
  }
  return '当前文档正文为空，暂无法问答。请先编辑并保存正文。'
}

export function buildReadingWelcomeSuggestions(
  title: string,
  category: string,
  format: DocWritingFormat,
  getDocumentContent: () => string,
): WelcomeSuggestion[] {
  const subject = title.trim() || category.trim()
  const hasBody = !isDocumentBodyEmpty(getDocumentContent(), format)
  if (!hasBody) return []

  const topic = subject ? `「${subject}」` : '这篇文档'
  return [
    {
      label: `${topic}主要讲了什么？`,
      prompt: '请用 3～5 句话概括这篇文档的核心内容与目的，只依据正文，不要编造。',
    },
    {
      label: '列出关键要点',
      prompt: '请列出文档中的关键要点（条列式），每条一句话，并标注是否在正文中明确出现。',
    },
    {
      label: '文档结构摘要',
      prompt: '请说明文档的结构（章节/板块）以及各部分分别说明了什么。',
    },
    {
      label: '有哪些结论或建议',
      prompt: '文档中提出了哪些结论、建议或待办？若未提及请说明。',
    },
  ]
}
